import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-user-card-square',
  templateUrl: './user-card-square.component.html',
  styleUrls: ['./user-card-square.component.scss']
})
export class UserCardSquareComponent implements OnInit {
  @Input() user: any;
  @Input() routeToProfile = true;
  constructor() { }

  ngOnInit() {
    console.log("user--",this.user);
    
  }

}
